import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskTicketAttachmentContent } from 'src/app/interfaces/zendesk-ticket-attachment-content';

import { BaseModel } from './base-model';
import { ZendeskTicket } from './zendesk-ticket';
import { ZendeskTicketComment } from './zendesk-ticket-comment';

export class ZendeskTicketAttachment extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskTicketAttachmentProperties: (
    | {
        property: keyof ZendeskTicketAttachment;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskTicketAttachment;
        type: 'alias';
      }
    | {
        property: keyof ZendeskTicketAttachment;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    {
      property: 'ZendeskTicketAttachmentId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'ZendeskTicketId', type: 'column', dataType: 'number' },
    { property: 'LocalZendeskTicketId', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketCommentId', type: 'column', dataType: 'number' },
    {
      property: 'LocalZendeskTicketCommentId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'attachmentUrl', type: 'column', dataType: 'string' },
    { property: 'fileName', type: 'column', dataType: 'string' },
    {
      property: 'ticketAttachmentContentJSON',
      type: 'column',
      dataType: 'JSON'
    },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ZendeskTicketAttachment.ZendeskTicketAttachmentProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ZendeskTicketAttachment.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ZendeskTicketAttachment.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ZendeskTicketAttachment.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(ZendeskTicketAttachmentObject: Partial<ZendeskTicketAttachment>) {
    super();

    ZendeskTicketAttachment.ZendeskTicketAttachmentProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ZendeskTicketAttachmentObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ZendeskTicketAttachmentId?: string;
  ZendeskTicketId?: string;
  LocalZendeskTicketId?: number;
  ZendeskTicketCommentId?: string;
  LocalZendeskTicketCommentId?: number;
  attachmentUrl?: string;
  fileName?: string;
  ticketAttachmentContentJSON?: ZendeskTicketAttachmentContent;
  createdAt?: Date;
  updatedAt?: Date;

  ZendeskTicket?: ZendeskTicket;
  ZendeskTicketComment?: ZendeskTicketComment;
}
